import { render, staticRenderFns } from "./AboutDataDeletionModal.vue?vue&type=template&id=f33c1a6e&scoped=true&"
import script from "./AboutDataDeletionModal.vue?vue&type=script&lang=ts&"
export * from "./AboutDataDeletionModal.vue?vue&type=script&lang=ts&"
import style0 from "./AboutDataDeletionModal.vue?vue&type=style&index=0&id=f33c1a6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33c1a6e",
  null
  
)

export default component.exports